import "core-js/modules/es6.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'FibOptionGroup',
  props: {
    type: {
      type: String,
      default: 'radio'
    },
    color: {
      type: String,
      default: ''
    },
    left: {
      type: Boolean
    },
    inline: {
      type: Boolean
    },
    options: {
      type: Array,
      required: true
    },
    value: {
      type: [Boolean, Number, String],
      default: false
    }
  },
  computed: {
    theme: function theme() {
      return this.$store.getters['theme/theme'];
    },
    themeStyle: function themeStyle() {
      return {
        color: this.color || this.theme.primaryColor
      };
    }
  },
  methods: {
    handleChange: function handleChange(value) {
      this.$emit('input', value);
    }
  }
};